import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PathStore } from "../store/path.store";
import { CommunicationDAO, CommunicationsResDAO, NotificatioDAO, NotificationsResDAO } from '../models/DAO/messagges';
import { AuthService } from './auth/auth.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  // [x]: F24 - communications & notifications
  public loadingOperation: boolean = false;

  public communicationsNotReadCollection: any[] = [];
  public numOfCommunications: number = 0;
  public notificationsNotReadCollection: any[] = [];
  public numOfNotifications: number = 0;
  // Comunicazioni ENTE
  public numOfCommunicationsEnte: number = 0;

  public communicationsCollection: any[] = [];
  public notificationsCollection: any = [];
  public communicationsEnteCollection: any[] = [];

  private profileId = '';

  constructor(
    private http: HttpClient,
    private path: PathStore,
    public authService: AuthService,
    private userService: UserService
  ) {}

  getProfileId() {
    let guid = '';
    if(this.authService.isLogged() && this.userService.userProfile != null) {
      guid = `${this.userService.userProfile.id}`;
    }
    this.profileId = guid;
  }
  ////////// COMMUNICATIONS
  getNewGenericCommunications(): Observable<CommunicationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/comunicazioni/nuove?idProfilo=${this.profileId}`;
    return this.http.get<CommunicationsResDAO>(url);
  }
  // Salvo nel localStorage SOLO le comunicazioni lette
  addCommunicationToLS(item: CommunicationDAO) {
    const communicationsRead = localStorage.getItem('communicationsRead');
    if(communicationsRead && communicationsRead != null && communicationsRead != '') {
      const communicationsFromLS = JSON.parse(communicationsRead);
      communicationsFromLS.push(item);
      localStorage.setItem('communicationsRead', JSON.stringify(communicationsFromLS));
    } else {
      const commArray: CommunicationDAO[] = [];
      commArray.push(item);
      localStorage.setItem('communicationsRead', JSON.stringify(commArray));
    }
  }
  // AUTENTICATO:recupero i dati dal BE (passando il valore profileId) e controllo il campo LETTA
  // ANONIMO: controllo quello nel localStorage
  parsingCommunicationsHeaderCollection(communicationsHeader: CommunicationDAO[]) {
    if(this.authService.isLogged()) {
      this.communicationsNotReadCollection = communicationsHeader;
      this.numOfCommunications = communicationsHeader.length;
    } else {
      const communicationsRead = localStorage.getItem('communicationsRead');
      if(communicationsRead && communicationsRead != null && communicationsRead != '') {
        const communicationsFromLS = JSON.parse(communicationsRead);
        // HEADER
        if(communicationsHeader.length > 0) {
          this.numOfCommunications = communicationsHeader.length;
          for (let indexBE = 0; indexBE < communicationsHeader.length; indexBE++) {
            const commFromHeader = communicationsHeader[indexBE];
            for (let indexLS = 0; indexLS < communicationsFromLS.length; indexLS++) {
              const commFromLS = communicationsFromLS[indexLS];
              if(commFromHeader.id == commFromLS.id) {
                // Dovrebbe essere sempre TRUE perchè nel LS salvo solo quelle marcate come lette
                if(commFromLS.letta) {
                  communicationsHeader[indexBE].letta = true;
                  this.numOfCommunications--;
                }
              }
            }
          }
        }
        this.communicationsNotReadCollection = communicationsHeader;
      } else {
        this.numOfCommunications = communicationsHeader.length;
        this.communicationsNotReadCollection = communicationsHeader;
      }
    }
  }
  // AUTENTICATO:recupero i dati dal BE (passando il valore profileId) e controllo il campo LETTA
  // ANONIMO: controllo quello nel localStorage
  parsingCommunicationsPageCollection(communicationsPage: CommunicationDAO[]) {
    if(this.authService.isLogged()) {
      this.communicationsCollection = communicationsPage;
    } else {
      const communicationsRead = localStorage.getItem('communicationsRead');
      if(communicationsRead && communicationsRead != null && communicationsRead != '') {
        const communicationsFromLS = JSON.parse(communicationsRead);
        // PAGE
        if(communicationsPage.length > 0) {
          for (let indexBE = 0; indexBE < communicationsPage.length; indexBE++) {
            const commFromPage = communicationsPage[indexBE];
            for (let indexLS = 0; indexLS < communicationsFromLS.length; indexLS++) {
              const commFromLS = communicationsFromLS[indexLS];
              if(commFromPage.id == commFromLS.id) {
                // Dovrebbe essere sempre TRUE perchè nel LS salvo solo quelle marcate come lette
                if(commFromLS.letta) {
                  communicationsPage[indexBE].letta = true;
                }
              }
            }
          }
        }
        this.communicationsCollection = communicationsPage;
      } else {
        this.communicationsCollection = communicationsPage;
      }
    }
  }

  ////////// NOTIFICATIONS
  getNewGenericNotifications(): Observable<NotificationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/notifiche/nuove?idProfilo=${this.profileId}`;
    return this.http.get<NotificationsResDAO>(url);
  }
  // Salvo nel localStorage SOLO le notifiche lette
  addNotificationToLS(item: NotificatioDAO) {
    const notificationsRead = localStorage.getItem('notificationsRead');
    if(notificationsRead && notificationsRead != null && notificationsRead != '') {
      const notificationsFromLS = JSON.parse(notificationsRead);
      notificationsFromLS.push(item);
      localStorage.setItem('notificationsRead', JSON.stringify(notificationsFromLS));
    } else {
      const notifArray: NotificatioDAO[] = [];
      notifArray.push(item);
      localStorage.setItem('notificationsRead', JSON.stringify(notifArray));
    }
  }
  // AUTENTICATO:recupero i dati dal BE (passando il valore profileId) e controllo il campo LETTA
  // ANONIMO: controllo quello nel localStorage
  parsingNotificationsHeaderCollection(notificationsHeader: NotificatioDAO[]) {
    if(this.authService.isLogged()) {
      this.notificationsNotReadCollection = notificationsHeader;
      this.numOfNotifications = notificationsHeader.length;
    } else {
      const notificationsRead = localStorage.getItem('notificationsRead');
      if(notificationsRead && notificationsRead != null && notificationsRead != '') {
        const notificationsFromLS = JSON.parse(notificationsRead);
        // HEADER
        if(notificationsHeader.length > 0) {
          this.numOfNotifications = notificationsHeader.length;
          for (let indexBE = 0; indexBE < notificationsHeader.length; indexBE++) {
            const commFromHeader = notificationsHeader[indexBE];
            for (let indexLS = 0; indexLS < notificationsFromLS.length; indexLS++) {
              const commFromLS = notificationsFromLS[indexLS];
              if(commFromHeader.id == commFromLS.id) {
                // Dovrebbe essere sempre TRUE perchè nel LS salvo solo quelle marcate come lette
                if(commFromLS.letta) {
                  notificationsHeader[indexBE].letta = true;
                  this.numOfNotifications--;
                }
              }
            }
          }
        }
        this.notificationsNotReadCollection = notificationsHeader;
      } else {
        this.numOfNotifications = notificationsHeader.length;
        this.notificationsNotReadCollection = notificationsHeader;
      }
    }
  }
  // AUTENTICATO:recupero i dati dal BE (passando il valore profileId) e controllo il campo LETTA
  // ANONIMO: controllo quello nel localStorage
  parsingNotificationsPageCollection(notificationsPage: NotificatioDAO[]) {
    if(this.authService.isLogged()) {
      this.notificationsCollection = notificationsPage;
    } else {
      const notificationsRead = localStorage.getItem('notificationsRead');
      if(notificationsRead && notificationsRead != null && notificationsRead != '') {
        const notificationsFromLS = JSON.parse(notificationsRead);
        // PAGE
        if(notificationsPage.length > 0) {
          for (let indexBE = 0; indexBE < notificationsPage.length; indexBE++) {
            const notifFromPage = notificationsPage[indexBE];
            for (let indexLS = 0; indexLS < notificationsFromLS.length; indexLS++) {
              const notifFromLS = notificationsFromLS[indexLS];
              if(notifFromPage.id == notifFromLS.id) {
                // Dovrebbe essere sempre TRUE perchè nel LS salvo solo quelle marcate come lette
                if(notifFromLS.letta) {
                  notificationsPage[indexBE].letta = true;
                }
              }
            }
          }
        }
        this.notificationsCollection = notificationsPage;
      } else {
        this.notificationsCollection = notificationsPage;
      }
    }
  }

  ////////// HP ente
  getNewCommunicationsEnte(type: string, enteId: string): Observable<CommunicationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/comunicazioni/nuove/${enteId}?idProfilo=${this.profileId}`;
    if(type == 'debug') {
      url = './assets/mockdata/F24_communications_ente.json';
    }
    return this.http.get<CommunicationsResDAO>(url);
  }
  // AUTENTICATO:recupero i dati dal BE (passando il valore profileId) e controllo il campo LETTA
  // ANONIMO: controllo quello nel localStorage
  parsingCommunicationsEnte(communications: CommunicationDAO[]) {
    this.numOfCommunicationsEnte = communications.length;

    if(this.authService.isLogged()) {
      this.numOfCommunicationsEnte = communications.length;
      this.communicationsEnteCollection = communications;
    } else {
      const communicationsEnteRead = localStorage.getItem('communicationsEnteRead');
      if(communicationsEnteRead && communicationsEnteRead != null && communicationsEnteRead != '') {
        const communicationsEnteFromLS = JSON.parse(communicationsEnteRead);
        // PAGE
        if(communications.length > 0) {
          for (let indexBE = 0; indexBE < communications.length; indexBE++) {
            const commFromPage = communications[indexBE];
            for (let indexLS = 0; indexLS < communicationsEnteFromLS.length; indexLS++) {
              const commFromLS = communicationsEnteFromLS[indexLS];
              if(commFromPage.id == commFromLS.id) {
                // Dovrebbe essere sempre TRUE perchè nel LS salvo solo quelle marcate come lette
                if(commFromLS.letta) {
                  communications[indexBE].letta = true;
                  this.numOfCommunicationsEnte--;
                }
              }
            }
          }
        }
        this.communicationsEnteCollection = communications;
      } else {
        this.communicationsEnteCollection = communications;
      }
    }
  }

  ////////// Pagine dedicate
  getNotifications(type: string, pageNumber: number, pageSize: number): Observable<NotificationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/notifiche/generiche?idProfilo=${this.profileId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if(type == 'debug') {
      url = './assets/mockdata/F24_notifications.json';
    }
    return this.http.get<NotificationsResDAO>(url);
  }
  getCommunications(type: string, pageNumber: number, pageSize: number): Observable<CommunicationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/comunicazioni/generiche?idProfilo=${this.profileId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if(type == 'debug') {
      url = './assets/mockdata/F24_communications.json';
    }
    return this.http.get<CommunicationsResDAO>(url);
  }
  getCommunicationsEnte(type: string, enteId: string, pageNumber: number, pageSize: number): Observable<CommunicationsResDAO> {
    this.getProfileId();
    let url = `${this.path.messagesUrl}/comunicazioni/${enteId}?idProfilo=${this.profileId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if(type == 'debug') {
      url = './assets/mockdata/F24_communications_ente.json';
    }
    return this.http.get<CommunicationsResDAO>(url);
  }
  /**
   * Salvo nel localStorage SOLO le comunicazioni lette
   * @param item
   * @param index
   */
  addEnteCommunicationToLS(item: CommunicationDAO) {
    const communicationsEnteRead = localStorage.getItem('communicationsEnteRead');
    if(communicationsEnteRead && communicationsEnteRead != null && communicationsEnteRead != '') {
      const communicationsFromLS = JSON.parse(communicationsEnteRead);
      communicationsFromLS.push(item);
      localStorage.setItem('communicationsEnteRead', JSON.stringify(communicationsFromLS));
    } else {
      const commArray: CommunicationDAO[] = [];
      commArray.push(item);
      localStorage.setItem('communicationsEnteRead', JSON.stringify(commArray));
    }
  }

  // Operation
  checkMessageAsRead(type: string, id: string): Observable<void> {
    let url = `${this.path.messagesUrl}`;
    if(type == 'notification') {
      url += `/notifiche/mark-notification-read/${id}?idProfilo=${this.profileId}`;
    }
    if(type == 'communication') {
      url += `/comunicazioni/mark-communication-read/${id}?idProfilo=${this.profileId}`;
    }
    const payload = {
      id: id
    }
    return this.http.post<void>(url, payload);
  }
}
